
/**
 * @name: 商城管理-热销商品
 * @author: Mobai
 * @date: 2024-05-13 11:37
 * @description： 商城管理-热销商品
 * @update: 2024-05-13 11:37
 */
import { Vue, Component, Watch } from "vue-property-decorator"
import {
  sortProductTreeApi,
  hotCreateApi,
  hotModifyStatusApi,
  hotPageApi,
  hotRemoveApi
} from '@/apis/mall/hot'
import type {
  IHot,
  IHotParams
} from '@/apis/mall/hot/types'
import { sortPageApi } from '@/apis/product/sort'
import type { ICrudOption } from "@/types/m-ui-crud"
import { IProductSort } from "@/apis/product/sort/types";

@Component({})
export default class mallHot extends Vue {
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: IHot[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IHotParams = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<IHot> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    column: [
      {
        label: '',
        type: 'selection',
        width: 50,
        align: 'center',
        selectable: (row: any, index: number) => {
          return row.isShow == 2
        }
      },
      {
        label: "商品编号",
        prop: "productId",
        align: "center",
        width: 180,
      },
      {
        label: "商品",
        prop: "productName",
        placeholder: '输入编号/名称模糊搜索',
        align: "center",
        hide: true,
        search: true
      },
      {
        label: "商品名称",
        prop: "productName",
        align: "center",
        overHidden: true
      },
      {
        label: "商品主图",
        prop: "productPic",
        align: "center",
        type: 'image',
        imgSuffix: ';'
      },
      {
        label: "排序",
        prop: "sort",
        align: "center",
      },
      {
        label: "首页展示",
        prop: "isShow",
        align: "center",
        type: 'select',
        search: true,
        slot: true,
        dicData: [
          {
            label: '展示',
            value: 1
          },
          {
            label: '不展示',
            value: 2
          }
        ]
      },
      {
        label: '商品分类',
        prop: 'sortId',
        search: true,
        hide: true,
        searchSlot: true
      },
      {
        label: '商品分类',
        prop: 'sortName',
        align: "center"
      },
      {
        label: '零售价（元）',
        prop: 'retailPrice',
        align: "center"
      },
      {
        label: '状态',
        prop: 'status',
        search: true,
        align: "center",
        type: "select",
        dicData: [
          {
            label: '上架',
            value: 1
          },
          {
            label: '下架',
            value: 2
          }
        ]
      },
    ]
  }

  sortList: IProductSort[] = []

  selectRows: IHot[] = []

  addDialog = false

  filterText = ''

  options: any = []

  @Watch('filterText')
  filterTextChange (newVal: string) {
    if (this.$refs.tree) {
      // @ts-ignore
      this.$refs.tree.filter(newVal);
    }
  }

  get ids() {
    return this.selectRows.map(item => item.id)
  }

  switchStatus (id: string, isShow: number) {
    hotModifyStatusApi(id).then(e => {
      this.$message.success('操作成功!')
      this.getList()
    })
  }

  getSortProduct () {
    return new Promise(resolve => {
      sortProductTreeApi({}).then(e => {
        this.options = e;
        resolve(e)
      })
    })
  }

  async openAdd () {
    await this.getSortProduct()
    this.addDialog = true
  }

  addEnter (done: Function, loading: Function) {
    // @ts-ignore
    const arr: any = this.$refs.tree.getCheckedNodes()
    if (!arr || !arr.length) {
      this.$message.error('请选择数据')
      loading()
      return
    }
    const productArr: string[] = arr.filter((item: any) => item.productId).map((item: any) => item.productId)
    if (!productArr || !productArr.length) {
      this.$message.error('请选择商品数据')
      loading()
      return
    }
    hotCreateApi({ids: productArr}).then(e => {
      if (e) {
        this.$message.success('操作成功!')
        this.getList()
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  addClose () {
    this.filterText = ''
  }

  batchRemove (arr: string[]) {
    if (!arr || !arr.length) {
      return this.$message.error('请选择数据')
    }
    this.$confirm('是否确认移除？', '提示', {
      type: 'warning',
    }).then(() => {
      hotRemoveApi(arr).then(e => {
        if (e) {
          this.$message.success('操作成功!')
          this.getList()
        }
      })
    }).catch(() => {
    })
  }

  getSortList (status?: number) {
    return new Promise(resolve => {
      sortPageApi({status}).then(e => {
        this.sortList = e;
        resolve(e)
      })
    })
  }

  filterNode (value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }

  getList () {
    this.tableLoading = true

    hotPageApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  created () {
    this.getSortList()
    this.getList()
  }
}
